import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { NavigationUtil } from 'utils/NavigationUtil';
import { RouteNames } from 'router';
import { CmsPagesActions } from 'modules/cmsPages/actions';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { HomeActions } from 'modules/home/actions';
import { HomeSelector } from 'modules/home/selector';
import { FooterActions } from 'modules/footerLink/actions';
import { FooterSelector } from 'modules/footerLink/selector';
import { AboutActions } from 'modules/about/actions';
import { CareerSelector } from 'modules/careers/selector';
import { CareerActions } from 'modules/careers/actions';
import { PageLoader } from 'components/molecules/pageLoader';
import AboutBanner from 'components/organisms/aboutTEBanner';
import { ContactUsSection } from 'components/templates/contactUsSection';
import FooterSection from 'components/templates/footer';
import PageTemplate from 'components/templates/pageTemplate';
import { useViewport } from 'components/templates/viewportProvider';
import VisionPhilosophySection from 'components/templates/vision&PhilosophySection';
import CultureLeadershipSection from 'components/templates/cultureLeadershipSection';
import NewsSection from 'components/templates/newsSection';
import { AboutPageSelector } from 'modules/about/selector';
import HistoryMomentsSection from 'components/templates/historyMomentsSection';
import Team from 'components/templates/team';
import JoinOurTeamAbout from 'components/templates/joinOurTeamAbout';
import { ShareModal } from 'components/templates/shareModal';
import { GetInTouchModal } from 'components/templates/getInTouchModal';
import { CmsDetailsSelector } from 'modules/cmsDetails/selector';
import { CmsDetailsActions } from 'modules/cmsDetails/actions';
import { TeamSelector } from 'modules/team/selector';
import { TeamActions } from 'modules/team/action';
import RenderSEO from 'components/atoms/renderSEO';

const About = props => {
  const {
    isLoading,
    getContactDetails,
    contact,
    getVerticals,
    verticals,
    verticalId,
    getSiteSettings,
    siteSettings,
    aboutBanner,
    getTeamData,
    teamData,
    getBannerData,
    visionPhilosophySection,
    getPageData,
    cmsDetailsData,
    getCmsDetailsData,
    ourDifferenceData,
    getAboutNews,
    newsData,
    historyMoments,
    jobPosts,
    getJobPosts,
    footerLink,
    getFooterLinkData,
  } = props;
  const metaTagSEO = {
    metaTitle: 'About Us | Total Environment',
    metaDescription:
      'Working together as an integrated team from concept to completion ensures that every little detail gets close attention for Total Environment projects. We take care of the architecture, interior design, project management and property maintenance all by ourself',
    metaKeywords: '',
  };
  const { isMobile } = useViewport();
  let [theme, setTheme] = useState(isMobile ? 'dark-theme' : 'light-theme');
  const [isGetInTouchModalOpen, setIsGetInTouchModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  useEffect(() => {
    getContactDetails();
    getVerticals();
    getSiteSettings();
    getBannerData();
    getCmsDetailsData();
    getPageData();
    getAboutNews();
    getJobPosts();
    getFooterLinkData();
    getCmsDetailsData();
    //TODO: used 10 as about verticalID because we have to hide this vertical.
    getTeamData(10);
  }, []);

  if (isLoading) {
    return <PageLoader isMobile={isMobile} />;
  }

  if (
    !aboutBanner ||
    !contact ||
    !siteSettings ||
    !verticals ||
    !ourDifferenceData ||
    !newsData ||
    !teamData ||
    !historyMoments ||
    !jobPosts ||
    !visionPhilosophySection ||
    !cmsDetailsData ||
    !footerLink
  ) {
    return null;
  }

  if (aboutBanner.metaTitle) metaTagSEO.metaTitle = aboutBanner.metaTitle;
  if (aboutBanner.metaDescription)
    metaTagSEO.metaDescription = aboutBanner.metaDescription;
  if (aboutBanner.metaKeywords)
    metaTagSEO.metaKeywords = aboutBanner.metaKeywords;

  // Get in touch
  const closeGetInTouchModal = () => {
    setIsGetInTouchModalOpen(false);
  };

  //share
  const closeShareModal = () => {
    setIsShareModalOpen(false);
  };

  const CampaignCode = contact.campaignCode ? contact.campaignCode : '';

  const componentList = [
    ...(!isEmpty(aboutBanner)
      ? [
          {
            component: AboutBanner,
            sectionId: 'banner',
            data: aboutBanner,
            theme: isMobile ? 'dark-theme' : 'light-theme',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'About',
                breadcrumbLink: RouteNames.about,
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(visionPhilosophySection)
      ? [
          {
            component: VisionPhilosophySection,
            data: {
              visionPhilosophySection,
              showButton: false,
              showCount: false,
            },
            theme: 'light-theme',
            sectionId: 'vision-and-philosophy',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'About',
                breadcrumbLink: RouteNames.about,
              },
              {
                breadcrumbName: 'Vision & Philosophy',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(teamData)
      ? [
          {
            component: Team,
            sectionId: 'team',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'About',
                breadcrumbLink: RouteNames.about,
              },
              {
                breadcrumbName: 'Leadership',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            data: {
              type: 'About',
              teamData,
              cmsDetailsData,
              show_desktop_overlay_button: true,
            },
          },
        ]
      : []),
    ...(!isEmpty(newsData.result_news_data) && !isMobile
      ? [
          {
            component: NewsSection,
            data: {
              newsData,
              sectionHeading: 'News',
              overlayButtonTextDesktop: 'SEE ALL NEWS',
              showNotificationButton: false,
              toggleId: false,
            },
            sectionId: 'news',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'About',
                breadcrumbLink: RouteNames.about,
              },
              {
                breadcrumbName: 'News',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
          },
        ]
      : []),
    ...(!isEmpty(historyMoments)
      ? [
          {
            component: HistoryMomentsSection,
            data: { historyMoments },
            sectionId: 'history-moments',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'About',
                breadcrumbLink: RouteNames.about,
              },
              {
                breadcrumbName: 'History',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    ...(!isEmpty(jobPosts)
      ? [
          {
            component: JoinOurTeamAbout,
            data: { jobPosts },
            sectionId: 'open-positions',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'About',
                breadcrumbLink: RouteNames.about,
              },
              {
                breadcrumbName: 'Join Us',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
          },
        ]
      : []),
    ...(!isEmpty(ourDifferenceData)
      ? [
          {
            component: CultureLeadershipSection,
            data: {
              ourDifferenceData,
              cmsDetailsData,
            },
            sectionId: 'culture-and-leadership',
            breadcrumbList: [
              {
                breadcrumbName: 'TotalEnvironment',
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: 'About',
                breadcrumbLink: RouteNames.about,
              },
              {
                breadcrumbName: 'Culture & Leadership Principles',
                breadcrumbLink: '#',
              },
            ],
            theme: 'light-theme',
          },
        ]
      : []),
    {
      component: ContactUsSection,
      data: { contact, verticals, verticalId, type: 'no-padding' },
      location: props,
      sectionId: 'contact',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'About',
          breadcrumbLink: RouteNames.about,
        },
        {
          breadcrumbName: 'Contact Us',
          breadcrumbLink: '#',
        },
      ],
      theme: 'light-theme',
    },
    {
      component: FooterSection,
      theme: 'dark-theme',
      sectionId: 'te-links',
      breadcrumbList: [
        {
          breadcrumbName: 'TotalEnvironment',
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: 'About',
          breadcrumbLink: RouteNames.about,
        },
        {
          breadcrumbName: 'Links',
          breadcrumbLink: '#',
        },
      ],
      data: { siteSettings, footerLink },
    },
  ];

  return (
    <div>
      <RenderSEO metaTags={metaTagSEO} />
      <PageTemplate
        theme={theme}
        componentList={componentList}
        updateTheme={e => setTheme(e)}
        verticals={verticals}
        siteSettings={siteSettings}
        campaignCode={CampaignCode}
        salesEmail={contact.email}
      />
      <GetInTouchModal
        isOpen={isGetInTouchModalOpen}
        onClosePress={closeGetInTouchModal}
        CampaignCode={CampaignCode}
        salesEmail={contact.email}
      />
      <ShareModal isOpen={isShareModalOpen} onClosePress={closeShareModal} />
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const verticalKey = NavigationUtil.getVerticalKeyForLocation(props.location);

  return {
    isLoading:
      HomeSelector.isLoading(state) ||
      FooterSelector.isLoading(state) ||
      CmsDetailsSelector.getCmsDetailsDataLoading(state) ||
      CmsPagesSelector.isCmsPageLoading(state) ||
      CareerSelector.getJobPostsLoading(state) ||
      CmsDetailsSelector.getCmsDetailsDataLoading(state) ||
      AboutPageSelector.getAboutNewsLoading(state),
    contact: HomeSelector.getContactForVertical(state, verticalKey),
    verticalId: HomeSelector.getVerticalIdForKey(verticalKey),
    verticals: HomeSelector.getVerticals(state),
    teamData: TeamSelector.getTeamData(state),
    footerLink: FooterSelector.getFooterData(state),
    siteSettings: HomeSelector.getSiteSettings(state),
    aboutBanner: HomeSelector.getBanners(state, false, '', 'About'),
    visionPhilosophySection: CmsPagesSelector.getVisionPhilosophy(
      state,
      'about',
      '',
      false
    ),
    ourDifferenceData: CmsPagesSelector.getOurDifferenceSection(
      state,
      'culture-leadership',
      'Culture & Leadership Principles'
    ),
    newsData: AboutPageSelector.getAboutNews(state, 'News'),
    historyMoments: CmsPagesSelector.getCmsPages(
      state,
      'History Moments',
      true
    ),
    jobPosts: CareerSelector.getJobPosts(state),
    cmsDetailsData: CmsDetailsSelector.getCmsDetailsData(state),
  };
};

const mapDispatchToProps = dispatch => {
  const {
    getVerticals,
    getSiteSettings,
    getBannerData,
    getContactDetails,
  } = HomeActions;
  const { getPageData } = CmsPagesActions;
  const { getAboutNews } = AboutActions;
  const { getTeamData } = TeamActions;
  const { getJobPosts } = CareerActions;
  const { getFooterLinkData } = FooterActions;
  const { getCmsDetailsData } = CmsDetailsActions;
  return bindActionCreators(
    {
      getContactDetails,
      getVerticals,
      getSiteSettings,
      getBannerData,
      getPageData,
      getTeamData,
      getAboutNews,
      getCmsDetailsData,
      getJobPosts,
      getFooterLinkData,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(About);
